import _axios from '@/services/axios';
import { Component, Vue } from 'vue-property-decorator';
import WithRender from './PayReferralCommission.html';
import config from "@/settings/config.js";

@WithRender
@Component({
})
export default class PayReferralCommission extends Vue {
    
    display = true;
    referrorName = "";
    referrorAgentCode = "";
    balance = "";
    amountToPay =0;
    busy = false;
    processing = false;
    referrorUserId="";

    onSubmit() {
        this.processing = false
        this.busy = true
    };

    onCancel() {
        this.busy = false
    };

    onOK() {
        this.processing = true
        this.onProcess();
    }

    mounted() {
        this.referrorUserId = this.$route.params.referrorUserId as string;
        this.referrorName = this.$route.params.referrorName as string;
        this.referrorAgentCode = this.$route.params.referrorAgentCode as string;
        this.balance = this.$route.params.balance as string;
    }

    async onProcess() {
        try {
            let dto = {
                "referrorUserId": this.referrorUserId,
                "amount": this.amountToPay
              }
            const response = await _axios.post(`${config.gateway}admin/internal/report/ReferalTransactionStatus/ReferralPayout`, dto);
            this.$bvToast.toast("done", {
                title: 'Notification',
                variant: 'success',
                autoHideDelay: 5000,
            });
            this.$router.push("referralCommissionReport");
        } catch (error) {
            this.$bvToast.toast(error.response.data, {
                title: 'Notification',
                variant: 'danger',
                autoHideDelay: 5000,
            });
            this.busy = false;
            this.processing = false;
        }
    }
}

